import React from "react";
import { FiPhone } from "react-icons/fi";
import OutboundTestForm from "../components/OutboundTestForm";

const VoiceTest = () => (
  <div>
    <h1 style={{ marginBottom: "2rem", color: "#2c3e50" }}>Voice call test</h1>
    <p
      style={{
        marginTop: "-1.25rem",
        marginBottom: "1.5rem",
        color: "#7f8c8d",
      }}
    >
      Send a test voice call using the same templates as production flows.
    </p>
    <OutboundTestForm
      mode="voice"
      title="Send voice call"
      icon={FiPhone}
      accentColor="#27ae60"
      submitLabel="Send voice call"
      sendingLabel="Sending..."
      successMessage="Voice call sent successfully!"
    />
  </div>
);

export default VoiceTest;
